<template>
  <div class="reviews" ref="result">
  </div>
</template>
<script>
export default {
  props: {
    place_id: {
      type: String
    }
  },
  name: 'Reviews',
  data: () => ({
    resultData: ''
  }),
  metaInfo () {
    return {
      script: [
        {
          src: `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_KEY}&libraries=places`,
          async: true,
          defer: true,
          callback: () => this.ReviewsInit() // will declare it in methods
        }
      ]
    }
  },
  methods: {
    ReviewsInit () {
      this.service = new window.google.maps.places.PlacesService(this.$refs.result)
      
    }
  },
  mounted () {
  }
}
</script>

<style type="scss">
  .autocomplete-items {
    position: absolute;
    border: 1px solid #d4d4d4;
    border-bottom: none;
    border-top: none;
    z-index: 99;
    /*position the autocomplete items to be the same width as the container:*/
    top: 100%;
    left: 0;
    right: 0;
    background: white;
  }
  .autocomplete-items li {
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #c3c3c3;
  }
  .autocomplete-items li:hover {
    /*when hovering an item:*/
    background-color: #e9e9e9;
  }
  .autocomplete-active {
    /*when navigating through the items using the arrow keys:*/
    background-color: DodgerBlue !important;
    color: #ffffff;
  }
  .autocomplete {
    /*the container must be positioned relative:*/
    position: relative;
    display: inline-block;
  }
</style>
